import React, { useReducer, ReactNode } from 'react';
import { CartContextType, defaultCartContext } from '../models/cart.interface';
import { cartReducer, CartAction } from '../reducers/cartReducer'; 

export const CartContext = React.createContext<{
  state: CartContextType;
  dispatch: React.Dispatch<CartAction>
}>({
  state: defaultCartContext,
  dispatch: () => undefined,
});

export type Props = {
  children: ReactNode;
};

export const CartContextProvider = ({ children }: Props) => { 
  const [ state, dispatch ] = useReducer(cartReducer, defaultCartContext);

  return (
    <CartContext.Provider value={{state, dispatch}}>
      {children}
    </CartContext.Provider>
  );
};

export function useCartContext() {
  const context = React.useContext(CartContext)
  
  if(context === undefined){
    throw new Error('useCartContext must be used within a CartContextProvider')
  }

  return context;
}

export const CartContextConsumer = CartContext.Consumer;
